import { render } from "./DatosGrid.vue?vue&type=template&id=4a9e529b&scoped=true"
import script from "./DatosGrid.vue?vue&type=script&lang=js"
export * from "./DatosGrid.vue?vue&type=script&lang=js"

import "./DatosGrid.vue?vue&type=style&index=0&id=4a9e529b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e529b"]])

export default __exports__